module.exports = __webpack_public_path__ + "img/icon_success.fc3972cc.png";